import { useQuery } from '@tanstack/react-query';

import { defaultStaleTime, queryKeys } from '@/lib/react-query';
import { BookingType, Gender } from '@/models';
import { ResourcesControllerFindAllV1Params, getSMPBackendAPIAdmin } from '@/proxy';
import { toResource } from '@/services/resource.service';

export type GetResourcesParams = {
  languages?: string[];
  excludeCustomers?: string[];
  serviceBookingTypes?: BookingType[];
  states?: string[];
  cities?: string[];
  archived?: boolean;
  genders?: Gender[];
  locations?: string[];
};

function toRequestParams(params?: GetResourcesParams): ResourcesControllerFindAllV1Params {
  return {
    includeLanguages: params?.languages?.filter((lang) => lang !== ''),
    excludeCustomers: params?.excludeCustomers?.filter((customer) => customer !== ''),
    serviceBookingTypes: params?.serviceBookingTypes,
    genders: params?.genders,
    states: params?.states,
    cities: params?.cities,
    archived: params?.archived ?? false,
    locations: params?.locations,
  };
}

function getResources(params?: GetResourcesParams) {
  const requestParams = toRequestParams(params);
  return getSMPBackendAPIAdmin().resourcesControllerFindAllV1(requestParams);
}

export function useResources(params?: GetResourcesParams) {
  return useQuery({
    queryKey: queryKeys.resources.lists(params),
    queryFn: () => getResources(params),
    select: (data) => data.map(toResource),
    staleTime: defaultStaleTime,
  });
}
